const ROLES_GESTOR_JUSTIFICATIVA_FALTA = [
  "secretario",
  "secretario-escolar",
  "coordenador",
  "direção",
  "admin",
  "super-admin",
];

export default ROLES_GESTOR_JUSTIFICATIVA_FALTA;
